import { SEASON, seasonOn, type Season } from '../../shared/season.ts';

/**
 * The season, as the game sees it. What the season is lives in
 * shared/season.ts; this decides whether it is on for this player today and
 * whether they have seen its card.
 */

export type { Season };

const SEEN_KEY = 'idrift.seasonSeen';

/**
 * ?season in the address shows the season whatever the date (?season=off
 * hides it), and shows its card every time: for checking a season before it
 * starts, or after the card has been dismissed. Not remembered. The icons and
 * the title logo are the Worker's to choose, by date, so they do not follow it.
 */
function override(): 'on' | 'off' | null {
  try {
    const param = new URLSearchParams(window.location.search).get('season');
    if (param === null) return null;
    return param === 'off' || param === '0' ? 'off' : 'on';
  } catch {
    return null;
  }
}

/** The season in force today, or null. */
export function activeSeason(now: Date = new Date()): Season | null {
  const forced = override();
  if (forced) return forced === 'on' ? SEASON : null;
  return seasonOn(now);
}

/** Whether this route is dressed today. */
export function seasonFor(routeId: string): Season | null {
  const season = activeSeason();
  return season && season.routes.includes(routeId) ? season : null;
}

/** The card to show on opening the game, once per device per season, or null. */
export function greetingDue(): Season | null {
  const season = activeSeason();
  if (!season) return null;
  if (override() === 'on') return season;
  try {
    return localStorage.getItem(SEEN_KEY) === season.id ? null : season;
  } catch {
    return season;
  }
}

export function markGreetingSeen(season: Season): void {
  try {
    localStorage.setItem(SEEN_KEY, season.id);
  } catch {
    // Private browsing: the card shows again next time, which is harmless.
  }
}
